import initTypes from './initTypes'

const initialState = {
  equipmentTypes: [],
  loadingEquipmentTypes: false,
  errorEquipmentTypes: null,
  timeZones: [{ timezone_id: 1, timezone: 'Alpha Time Zone', abbreviation: 'A', location: 'Military', offset: 1 }],
  loadTimeZone: false,
  errorTimeZone: '',
  hotOffers: 0,
  seenHotOffersIds: [],
  avatar: null,
  offers: 0
}

const getNotSeenHotOffers = (hotOffers, seenHotOffers) => hotOffers
  ? hotOffers.filter(offer => !seenHotOffers.includes(offer.orderNumber))
  : []

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case initTypes.GET_EQUIPMENT_TYPES :
      return {
        ...state,
        loadingEquipmentTypes: true,
        errorEquipmentTypes: null
      }

    case initTypes.GET_EQUIPMENT_TYPES_SUCCESS:
      return {
        ...state,
        equipmentTypes: payload,
        loadingEquipmentTypes: false,
        errorEquipmentTypes: null
      }

    case initTypes.GET_EQUIPMENT_TYPES_FAILURE:
      return {
        ...state,
        equipmentTypes: [],
        loadingEquipmentTypes: false,
        errorEquipmentTypes: payload
      }

    case initTypes.GET_TIMEZONE :
      return {
        ...state,
        loadTimeZone: true,
        errorTimeZone: null
      }

    case initTypes.GET_TIMEZONE_SUCCESS:
      return {
        ...state,
        timeZones: payload,
        loadTimeZone: false,
        errorTimeZone: null
      }

    case initTypes.GET_TIMEZONE_FAILURE:
      return {
        ...state,
        timeZones: [],
        loadTimeZone: false,
        errorTimeZone: payload
      }

    case initTypes.GET_HOT_OFFERS_SUCCESS: {
      const { data } = payload
      const notSeenHotOffers = getNotSeenHotOffers(data, state.seenHotOffersIds)
      return {
        ...state,
        hotOffers: notSeenHotOffers.length
      }
    }

    case initTypes.GET_OFFERS_SUCCESS: {
      return {
        ...state,
        offers: payload
      }
    }

    case initTypes.HOT_OFFERS_SEEN: {
      const { data } = payload
      const notSeenHotOffers = getNotSeenHotOffers(data, state.seenHotOffersIds)
      return {
        ...state,
        hotOffers: 0,
        seenHotOffersIds: [
          ...state.seenHotOffersIds,
          ...notSeenHotOffers.map(offer => offer.orderNumber)
        ]
      }
    }

    case initTypes.GET_AVATAR_SUCCESS:
      return {
        ...state,
        avatar: payload
      }

    default:
      return state
  }
}
